// extracted by mini-css-extract-plugin
export default {"root":"ProductBadges_root__h2eVX","image":"ProductBadges_image__xUfUc"};